import React, { useState, useEffect } from 'react';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../../Dialog/Dialog';
import {
    Button,
    Grid,
    InputAdornment,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    DialogActions,
    InputBase,
    Typography,
    CardContent,
    Card,
    MenuItem
} from '@material-ui/core';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import * as logger from '../../../../logger';
import { AddInvoiceSideBarCss } from './AddInvoiceSideBarCss';
import CloseIcon from '@material-ui/icons/Close';
import Highlighter from "react-highlight-words";
import SearchIcon from '@material-ui/icons/Search';
import { getPartyLedgerData } from '../../../../store/actions/homeActionCreator';
import { updateChatView, invoiceConfig } from '../../../../store/actions/userActionCreators';
import { invoicesDefault, fetchInvoiceTrips, createInvoice, getInvoiceCustomers } from '../../../../store/actions/tripActionCreator';
import { RightArrow } from '../../TopCard/icons';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObjectIndex, getDateInStringDDMMMYYYY } from '../../../../utils/utils';
import { Form } from 'react-final-form';
import TextInputState from '../../Inputs/TextInputState';
import DateFnsUtils from '@date-io/date-fns';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { tripTableHeight, tableHeightWithSparkline } from "../../../../styleVariables";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import InvoiceTripInfoDialog from '../../Dialog/InvoiceTripInfoDialog';
import EnterDaysDialog from '../../Dialog/EnterDaysDialog';
import { SortIconVertical } from '../../../../components/icons';
import { trackDwebEvent } from '../../../analytics';
import { withRouter, useHistory } from 'react-router-dom';


const AddInvoiceSideBar = ({
    rightSideBarOpen,
    onClose,
    user,
    trip,
    dispatchChatView,
    dispatchFetchInvoiceTrips,
    dispatchGetInvoicesDefault,
    dispatchGetInvoiceConfig,
    dispatchCreateInvoice,
    dispatchGetInvoiceCustomers,
    onConfirm
}) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(rightSideBarOpen);
    const [searchTxt, setSearchTxt] = useState("");
    const [partyLedgerData, setPartyLedgerData] = useState([]);
    const [screen, setScreen] = useState("selectParty");
    const [selectedParty, setSelectedParty] = useState({});
    const [invoiceNumberValue, setInvoiceNumberValue] = useState("");
    const [invoiceDateValue, setInvoiceDateValue] = useState(new Date());
    const [dueDateValue, setDueDateValue] = useState("");
    const [invoiceConfigData, setInvoiceConfigData] = useState({ dueDays: [] });
    const [daysValue, setDaysValue] = useState("");
    const [invoiceTrips, setInvoiceTrips] = useState([]);
    const [dataIndexSelectedRow, setDataIndexSelectedRow] = useState([]);
    const [tripError, setTripError] = useState(true);
    const [showTripError, setShowTripError] = useState(false);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [infoDialog, setInfoDialog] = useState(false);
    const [selectedTripInfo, setSlectedTripInfo] = useState({});
    const [enterDaysFlag, setEnterDaysFlag] = useState(false);
    const [sortingText, setSortingText] = useState("Latest to Oldest");
    const [latestToOldestTrips, setLatestToOldestTrips] = useState([]);

    const getMuiTheme = (type) => createMuiTheme({
        overrides: {
            MuiDialog: {
                // Name of the rule
                paperFullScreen: {

                },
            },
            MuiList: {
                padding: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            },
            MUIDataTable: {
                paper: {
                    boxShadow: 'inset 0 -1px 0 0 #e1e1e1',
                    border: 'solid 1px #dcdcdc'
                },
                responsiveBase: {
                    //   border: '1px solid #dfe2e5',
                    borderRadius: 4,
                }
            },
            MuiPaper: {
                '& .MUIDataTableFilterList-root': {
                    display: 'none'
                }
            },
            MUIDataTableHead: {
            },
            MUIDataTableBodyRow: {
                root: {
                    height: 52,
                    maxHeight: 52,
                    minHeight: 52,
                    fontWeight: 300,
                    cursor: 'pointer',
                    '&:nth-of-type(even)': {
                        backgroundColor: '#f1f1f3',
                    },
                }
            },
            MUIDataTableHeadRow: {
                root: {
                    height: 52,
                    maxHeight: 52,
                    minHeight: 52,
                }
            },
            MUIDataTableSelectCell: {
                fixedHeader: {
                    backgroundColor: "#f1f1f3"
                },
                headerCell: {
                    backgroundColor: "#f1f1f3"
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    backgroundColor: "#f1f1f3",
                    fontWeight: 'bold'
                },
                sortLabelRoot: {
                    height: 'auto'
                },
                fixedHeader: {
                    backgroundColor: "#e3e8fd",
                    //   border: '1px solid #dfe2e5',
                    paddingBottom: 10,
                    paddingTop: 10,
                    top: -1
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    fontWeight: 'bold',
                    color: '#161f34'
                },
                stackedParent: {
                    //   border: '1px solid #dfe2e5',
                    borderTop: 'none',
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            MUIDataTableSearch: {
                searchText: {
                    '& .MuiInputBase-root': {
                        height: 36,
                        '& .MuiInputAdornment-root': {
                            color: '#B8B8B8'
                        }
                    }
                },
                searchIcon: {
                    display: 'none'
                },
                clearIcon: {
                    display: 'none'
                }
            },
            MUIDataTableFilterList: {
            },
            MUIDataTableToolbar: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 24,
                    paddingBottom: 24
                },
                filterPaper: {
                    minWidth: '30em'
                }

            },
            MUIDataTableToolbarSelect: {
                root: {
                    display: 'none !important'
                }
            },
            MuiTableRow: {
                root: {
                    '&$selected': {
                        backgroundColor: '#f1f3fe !important'
                    }
                }
            },
            MuiTableCell: {
                head: {
                    backgroundColor: "#e3e8fd !important",
                }
            }
        }
    });

    const classes = AddInvoiceSideBarCss();
    let history = useHistory();


    const initialValues = {
        invoiceNumber: invoiceNumberValue,
        invoiceDate: invoiceDateValue,
        dueDate: dueDateValue,
        days: daysValue
    }

    useEffect(() => {
        dispatchChatView(false);
        dispatchGetInvoiceCustomers(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Customers Successfull');
                }
            },
            () => {
                logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Customers Failed');
            }
        )

        trackDwebEvent('Dweb Invoice create initiated', {});
    }, [rightSideBarOpen]);

    useEffect(() => {
        if (trip && trip.invoiceCustomers) {
            setPartyLedgerData(trip.invoiceCustomers);
        }

        if (user && user.invoiceConfig) {
            const configData = user.invoiceConfig;

            let indexValue;

            if (daysValue && configData && configData.dueDays && !configData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(daysValue))) {
                configData.dueDays.reduce(function (accumulator, days, index) {
                    if (Number(daysValue) > Number(days.quantity)) {
                        indexValue = index;
                    }
                });
                configData.dueDays.splice((indexValue + 1), 0, { display: daysValue + (daysValue == 1 ? ' Day' : ' Days'), unit: 'days', quantity: Number(daysValue) });
            }
            setInvoiceConfigData(configData);
        }

    }, [trip.invoiceCustomers, user.invoiceConfig, daysValue]);

    useEffect(() => {
        if (trip && trip.invoiceTrips && trip.invoiceTrips.trips) {

            let invoiceTripsInfo = trip && trip.invoiceTrips && trip.invoiceTrips.trips ? (trip.invoiceTrips.trips).slice() : [];

            // **************************************** Sorting Latest to oldest trips based on trip start date. ****************************************
            invoiceTripsInfo.sort(function (a, b) {
                return new Date(b.startDate) - new Date(a.startDate);
            });

            setLatestToOldestTrips(invoiceTripsInfo);
            setInvoiceTrips(invoiceTripsInfo);

        }


    }, [trip.invoiceTrips]);

    const handleClose = () => {
        setPartyLedgerData([]);
        onClose();
        setDialogOpen(false);
        dispatchChatView(true);

        if (screen == "invoiceDetails") {
            let invoiceAmount = 0;

            dataIndexSelectedRow.map((rowData, index) => (
                invoiceAmount += invoiceTrips && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""] && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance ? invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance : 0
            ));

            trackDwebEvent('Dweb Invoice create form page cancelled', {
                count_of_trips: dataIndexSelectedRow && dataIndexSelectedRow.length ? dataIndexSelectedRow.length : 0,
                total_invoice_amount: invoiceAmount,
                invoice_number: invoiceNumberValue ? invoiceNumberValue : "",
                invoice_date: dueDateValue ? dueDateValue : "",
                due_days: daysValue ? daysValue : "",
                party_name: selectedParty && selectedParty.customerName ? selectedParty.customerName : "",
                party_id: selectedParty && selectedParty.id ? selectedParty.id : "",
            })
        }

    }

    const handlePartySelect = (party) => {

        dispatchGetInvoiceConfig(
            (configData) => {
                if (configData && configData.status && configData.status.code == 200) {
                    logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Config Successfull');
                    dispatchGetInvoicesDefault(
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Successfull');

                                const dueInValue = data && data.response && data.response.invoiceDetails && data.response.invoiceDetails.dueIn ? data.response.invoiceDetails.dueIn : ""

                                // *********************************** Setting default values to fields. ***********************************
                                setInvoiceNumberValue(data && data.response && data.response.invoiceDetails && data.response.invoiceDetails.invoiceNumber ? data.response.invoiceDetails.invoiceNumber : "");
                                setDaysValue(dueInValue);
                                var dueDateCal = new Date();
                                dueDateCal.setDate(dueDateCal.getDate() + (dueInValue ? dueInValue : 0));
                                setDueDateValue(dueDateCal.setHours(0, 0, 0, 0));
                                dispatchFetchInvoiceTrips(party.id,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Trips Successfull');


                                            setScreen("invoiceDetails");


                                            setSelectedParty(party);

                                            trackDwebEvent('Dweb Invoice create form page', {
                                                party_name: party && party.customerName ? party.customerName : "",
                                                party_id: party && party.id ? party.id : "",
                                                party_balance: party && party.balance ? party.balance : ""
                                            });

                                            trackDwebEvent('Dweb Invoice create Party selected', {
                                                party_name: party && party.customerName ? party.customerName : "",
                                                party_id: party && party.id ? party.id : "",
                                                party_balance: party && party.balance ? party.balance : ""
                                            });
                                        }
                                    },
                                    () => {
                                        logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Trips Failed');
                                    }
                                )
                            }
                        },
                        () => {
                            logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Failed');
                        }
                    )
                }
            },
            () => {
                logger.log('Add Invoice Side Bar Dweb', 'Get Invoice Config Failed');
            }
        )

    }

    const handleBackClick = () => {
        setScreen('selectParty');
        let invoiceAmount = 0;

        dataIndexSelectedRow.map((rowData, index) => (
            invoiceAmount += invoiceTrips && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""] && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance ? invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance : 0
        ));

        trackDwebEvent('Dweb Invoice create form page cancelled', {
            count_of_trips: dataIndexSelectedRow && dataIndexSelectedRow.length ? dataIndexSelectedRow.length : 0,
            total_invoice_amount: invoiceAmount,
            invoice_number: invoiceNumberValue ? invoiceNumberValue : "",
            invoice_date: dueDateValue ? dueDateValue : "",
            due_days: daysValue ? daysValue : "",
            party_name: selectedParty && selectedParty.customerName ? selectedParty.customerName : "",
            party_id: selectedParty && selectedParty.id ? selectedParty.id : "",
        })
    }

    const onSubmit = async values => {

        let invoiceAmount = 0;

        if (dataIndexSelectedRow && dataIndexSelectedRow.length > 0) {
            setTripError(false);
            setShowTripError(false);

            const invoiceData = {
                allowDuplicateInvoiceNumber: false,
                tripIds: [],
                invoiceNumber: values && values.invoiceNumber ? values.invoiceNumber : "",
                customerId: selectedParty && selectedParty.id ? selectedParty.id : "",
                dueDate: values && values.dueDate ? Math.round(values.dueDate / 1000) : "",
                invoiceDate: values && values.invoiceDate ? Math.round((values.invoiceDate / 1000)) : ""
            }

            dataIndexSelectedRow.map((rowData, index) => (
                invoiceData.tripIds.push(invoiceTrips && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""] && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].id ? invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].id : "")
            ));
            dataIndexSelectedRow.map((rowData, index) => (
                invoiceAmount += invoiceTrips && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""] && invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance ? invoiceTrips[rowData && (rowData.dataIndex || rowData.dataIndex == 0) ? rowData.dataIndex : ""].balance : 0
            ));

            dispatchCreateInvoice(invoiceData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Invoice Side Bar Dweb', 'Create Invoice Successfull');
                        setDialogOpen(false);
                        onConfirm();

                        if (data.response && data.response.invoiceDetails && data.response.invoiceDetails.id) {
                            const invocieData = data.response.invoiceDetails;
                            history.push({
                                pathname: `/invoices/single-invoice/${invocieData && invocieData.id ? invocieData.id : ""}`,
                                state: {
                                    id: 7,
                                    pageTitle: invocieData && invocieData.invoiceNumber ? invocieData.invoiceNumber : "",
                                    pageSubTitle: invocieData && invocieData.dueStatus ? invocieData.dueStatus : "",
                                    invoiceId: invocieData && invocieData.id ? invocieData.id : ""
                                }
                            })
                        }

                        trackDwebEvent('Dweb Invoice create successful', {
                            count_of_trips: dataIndexSelectedRow && dataIndexSelectedRow.length ? dataIndexSelectedRow.length : 0,
                            total_invoice_amount: invoiceAmount,
                            invoice_number: values && values.invoiceNumber ? values.invoiceNumber : "",
                            invoice_date: values && values.invoiceDate ? Math.round((values.invoiceDate / 1000)):'',//getDateInStringDDMMMYYYY(Math.round((values.invoiceDate.setHours(0, 0, 0, 0) / 1000))) : "",
                            due_days: values && values.days ? values.days : "",
                            failure_reason: data && data.status && data.status.message ? data.status.message : "",
                            party_name: selectedParty && selectedParty.customerName ? selectedParty.customerName : "",
                            party_id: selectedParty && selectedParty.id ? selectedParty.id : "",
                            invoice_id: data && data.response && data.response.invoiceDetails && data.response.invoiceDetails.id ? data.response.invoiceDetails.id : ""
                        })
                    }
                },
                (data) => {
                    logger.log('Add Invoice Side Bar Dweb', 'Create Invoice Failed');
                    trackDwebEvent('Dweb Invoice create form page failed', {
                        count_of_trips: dataIndexSelectedRow && dataIndexSelectedRow.length ? dataIndexSelectedRow.length : 0,
                        total_invoice_amount: invoiceAmount,
                        invoice_number: values && values.invoiceNumber ? values.invoiceNumber : "",
                        invoice_date: values && values.invoiceDate ?Math.round((values.invoiceDate / 1000)) :'', //getDateInStringDDMMMYYYY(Math.round((values.invoiceDate.setHours(0, 0, 0, 0) / 1000))) : "",
                        due_days: values && values.days ? values.days : "",
                        failure_reason: data && data.status && data.status.message ? data.status.message : "",
                        party_name: selectedParty && selectedParty.customerName ? selectedParty.customerName : "",
                        party_id: selectedParty && selectedParty.id ? selectedParty.id : "",
                    })
                }
            );

        } else {
            setTripError(true);
            setShowTripError(true);
            return;
        }

    }

    const validate = values => {
        const errors = {};

        if (values && !values.invoiceNumber) {
            errors.invoiceNumber = "Please enter invoice number."
        }
        if (values && !values.invoiceDate) {
            errors.invoiceDate = "Please select invoice date."
        }
        if (values && !values.dueDate) {
            errors.dueDate = "Please select due date."
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;
    }

    const getFormFields = (values) => {


        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divContainer}>

                            <div className={classes.divContainerItem}>
                                <div className={classes.titleV3}>Invoice Number*</div>
                                <div className={classes.mtV3}>
                                    <TextInputState
                                        placeholder="Enter Invoice Number"
                                        name="invoiceNumber"
                                        margin="none"
                                        variant="outlined"
                                        size="small"
                                        onChange={(e) => {
                                            setInvoiceNumberValue(e.target.value)
                                        }}
                                        required={true}
                                        classes={{ root: classes.textFieldV1 }}
                                    />
                                </div>
                            </div>

                            <div className={classes.divContainerItem}>
                                <div className={classes.titleV3}>Invoice Date*</div>
                                <div className={classes.mtV3}>
                                    <DatePicker
                                        name="invoiceDate"
                                        margin="none"
                                        variant="inline"
                                        onChange={(date) => {
                                            setInvoiceDateValue(date.setHours(0, 0, 0, 0));
                                            let dueDateCal = new Date();
                                            dueDateCal.setDate(date.getDate() + (values && values.days ? Number(values.days) : 0));
                                            setDueDateValue(dueDateCal.setHours(0, 0, 0, 0));
                                        }}
                                        inputVariant="outlined"
                                        size="small"
                                        format="dd-MM-yyyy"
                                        placeholder="Select Date"
                                        dateFunsUtils={DateFnsUtils}
                                        required={true}
                                        className={classes.textFieldV1}
                                        InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                    />
                                </div>
                            </div>

                            <div>
                                <div className={classes.titleV3}>Due Date*</div>
                                <div className={classes.mtV3}>
                                    <DatePicker
                                        name="dueDate"
                                        margin="none"
                                        variant="inline"
                                        onChange={(date) => {
                                            handleDueDateChange(date, values.invoiceDate);
                                        }}
                                        inputVariant="outlined"
                                        size="small"
                                        minDate={invoiceDateValue}
                                        format="dd-MM-yyyy"
                                        placeholder="Select Date"
                                        dateFunsUtils={DateFnsUtils}
                                        required={true}
                                        className={classes.textFieldV1}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">
                                                <div className={classes.divAlignV2}>
                                                    <EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon>
                                                    <div>
                                                        <Select
                                                            name="days"
                                                            variant="outlined"
                                                            onChange={(e) => {
                                                                handleDaysSelectChange(e)
                                                            }}
                                                            onClose={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            formControlProps={{ margin: 'none', size: "small" }}
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left"
                                                                },
                                                                getContentAnchorEl: null
                                                            }}
                                                            required={true}
                                                            style={{ backgroundColor: '#efefef', color: '#7b7b7b', height: 26, marginLeft: 12 }}
                                                            classes={{ root: classes.selectRoot }}
                                                        >
                                                            {invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.map((dueData, index) => {
                                                                return (<MenuItem key={index} value={dueData.quantity} className={classes.menuItem} >{dueData.display}</MenuItem>);
                                                            })}
                                                        </Select>
                                                    </div>
                                                </div>
                                            </InputAdornment>
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </>
                )
            }
        ]
    }

    const muiColumns = [
        {
            name: "startDate",
            label: "Date",
            options: {
                filter: true,
                sort: false,
                searchable: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fwNormal}>{getDateInStringDDMMMYYYY(value)}</span>
                }
            },

        },
        {
            name: "id",
            label: "Route",
            options: {
                filter: true,
                sort: false,
                searchable: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = invoiceTrips && invoiceTrips.length > 0 && invoiceTrips[dataIndex] ? invoiceTrips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.divAlignV1}>
                                <div>{rowData && rowData.startLocation ? rowData.startLocation : ""}</div>
                                &nbsp;to&nbsp;
                                <div>{rowData && rowData.destinationLocation ? rowData.destinationLocation : ""}</div>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "truckNumber",
            label: "Truck",
            options: {
                filter: true,
                sort: false,
                searchable: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = invoiceTrips && invoiceTrips.length > 0 && invoiceTrips[dataIndex] ? invoiceTrips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.divAlign}>
                                {rowData && rowData.vehicleNumArray && rowData.vehicleNumArray.map((vehicleNumber, index) => (
                                    <div className={index != 0 ? classes.mlV1 : ""}>{vehicleNumber}</div>
                                ))}
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "balance",
            label: "Invoice Amount",
            options: {
                filter: true,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = invoiceTrips && invoiceTrips.length > 0 && invoiceTrips[dataIndex] ? invoiceTrips[dataIndex] : {}
                    return (
                        <>
                            <div className={classes.invoiceAmount}>
                                <div>{numberFormat(Number(rowData && rowData.balance ? rowData.balance : 0))}</div>
                                <div className={classes.mtV4}>
                                    <InfoOutlinedIcon className={classes.infoIcon}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleInfoClick(rowData);
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlignV1}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
    ];

    const muiData = invoiceTrips && invoiceTrips.length > 0 ? invoiceTrips : [];

    const options = {
        filterType: "checkbox",
        selectableRows: true,
        selectableRowsOnClick: true,
        searchOpen: false,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        selectableRowsHeader: false,
        onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
            setDataIndexSelectedRow(allRowsSelected);
            if (allRowsSelected && allRowsSelected.length > 0) {
                setTripError(false);
                setShowTripError(false);
            } else {
                setTripError(true);
                setShowTripError(true);
            }
        },
        textLabels: {
            body: {
                noMatch: "All Trips for this Party are already Invoiced.",
            }
        }
    }

    const handleInfoClick = (tripData) => {
        setInfoDialog(true);
        setSlectedTripInfo(tripData);
    }

    const handleInfoClose = () => {
        setInfoDialog(false);
        setSlectedTripInfo({});
    }

    const handleDueDateChange = (date, invoiceDateInfo) => {

        let indexValue;
        const invoiceDateDetails = invoiceDateInfo;

        const diffTime = Math.abs(Number(invoiceDateDetails) - Number(date.setHours(0, 0, 0, 0)));

        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.length > 0) {

            if ((diffDays || diffDays == 0) && invoiceConfigData && invoiceConfigData.dueDays && !invoiceConfigData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(diffDays))) {
                invoiceConfigData.dueDays.reduce(function (accumulator, days, index) {
                    if (Number(diffDays) > Number(days.quantity)) {
                        indexValue = index;
                    }
                });

                invoiceConfigData.dueDays.splice((indexValue + 1), 0, { display: diffDays + (diffDays == 1 ? ' Day' : ' Days'), unit: 'day', quantity: Number(diffDays) });
            }
        }

        setDueDateValue(date.setHours(0, 0, 0, 0));
        setDaysValue(diffDays);

    }

    const handleDaysSelectChange = (e) => {

        if (e && e.target && e.target.value == "Custom") {
            setEnterDaysFlag(true);
        } else {

            // ****************************** Calculating Invoice Due Date based on number of days. ****************************** 
            var dueDateCal = new Date(invoiceDateValue);
            dueDateCal.setDate(dueDateCal.getDate() + (e && e.target && e.target.value ? Number(e.target.value) : 0));
            setDaysValue(e.target.value);
            trackDwebEvent('Dweb Invoice create due date selected', {
                due_days: e.target.value
            });
            setDueDateValue(dueDateCal.setHours(0, 0, 0, 0));
            e.stopPropagation();
        }
    }

    const handleDaysDialogConfirm = (days) => {

        let indexValue;
        setDaysValue(days);
        trackDwebEvent('Dweb Invoice create due date selected', {
            due_days: days
        });
        setEnterDaysFlag(false);

        if (invoiceConfigData && invoiceConfigData.dueDays && invoiceConfigData.dueDays.length > 0) {
            // const searchDays = invoiceConfigData.dueDays.find(dueDaysData => Number(dueDaysData.quantity) == (days ? Number(days) : 0));

            // if (!searchDays) {
            if (days && invoiceConfigData && invoiceConfigData.dueDays && !invoiceConfigData.dueDays.some((dueDay) => Number(dueDay.quantity) === Number(days))) {
                invoiceConfigData.dueDays.reduce(function (accumulator, daysInfo, index) {
                    if (Number(days) > Number(daysInfo.quantity)) {
                        indexValue = index;
                    }
                });
                invoiceConfigData.dueDays.splice((indexValue + 1), 0, { display: days + (days == 1 ? ' Day' : ' Days'), unit: 'day', quantity: Number(days) });
            }
            // }
        }

        var dueDateCal = new Date(invoiceDateValue);
        dueDateCal.setDate(dueDateCal.getDate() + (days ? Number(days) : 0));
        setDueDateValue(dueDateCal.setHours(0, 0, 0, 0));
    }

    const handleDaysDialogClose = () => {
        setEnterDaysFlag(false);
    }

    const handleSortClick = () => {
        if (sortingText == "Latest to Oldest") {

            setSortingText("Oldest to Latest");
            if (trip && trip.invoiceTrips && trip.invoiceTrips.trips) {
                setInvoiceTrips(trip.invoiceTrips.trips);
            }

        } else if (sortingText == "Oldest to Latest") {

            setSortingText("Latest to Oldest");
            setInvoiceTrips(latestToOldestTrips);
        }
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: screen == "invoiceDetails" ? classes.invoiceDetailsDrawer : classes.partySelectDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-add-invoice"} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>

                        {screen == "selectParty" &&
                            <>
                                Select Party
                            </>
                        }
                        {screen == "invoiceDetails" &&
                            <>
                                Invoice Details
                            </>
                        }

                    </div>
                </SideBarDialogTitle>

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1}>

                    {/* ******************************************** Select Party Screen. ******************************************** */}
                    {screen == "selectParty" &&
                        <>
                            <div>
                                <div className={classes.search}>
                                    {!searchTxt && <div className={classes.searchIcon}>
                                        <SearchIcon className={classes.sicon} />
                                    </div>}
                                    {searchTxt && <div className={classes.closeIcon} onClick={(e) => { setSearchTxt("") }}>
                                        <CloseIcon className={classes.sicon} />
                                    </div>}
                                    <InputBase
                                        placeholder="Search for Party"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        onChange={(e) => { setSearchTxt(e.target.value) }}
                                        value={searchTxt}
                                        inputProps={{ 'aria-label': 'search' }}
                                    />
                                </div>
                                <div className={classes.listingDiv}>
                                    <div className={classes.subTitleSec} >
                                        <Typography className={classes.subTitleTxt}>Party Name</Typography>
                                        <Typography className={classes.subTitleTxt}>Balance</Typography>
                                    </div>
                                    {partyLedgerData && partyLedgerData.customers && partyLedgerData.customers.length > 0 && partyLedgerData.customers.filter(party => {
                                        return party && party.customerName.toLowerCase().indexOf(searchTxt.toLowerCase()) >= 0;
                                    }).map((party) => {
                                        return (
                                            <>
                                                <div className={classes.partyDiv} onClick={(e) => { handlePartySelect(party) }}>
                                                    <div className={classes.nameDiv}>
                                                        <Typography>
                                                            <Highlighter
                                                                highlightClassName={classes.highlight}
                                                                searchWords={[searchTxt]}
                                                                autoEscape={true}
                                                                textToHighlight={party && party.customerName ? party.customerName : ""}
                                                            />
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.balanceDiv} >
                                                        <Typography className={classes.partyBalance}>{numberFormat(party && party.balance ? party.balance : 0)}</Typography>
                                                        <RightArrow />
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                        </>
                    }

                    {/* *************************************** Invoice Details Screen. *************************************** */}
                    {screen == "invoiceDetails" &&
                        <>
                            <div className={classes.mtV1}>
                                <Grid
                                    container
                                    direction="row"
                                    wrap="nowrap"
                                    justify="space-between"
                                    alignItems="center"
                                    className={classes.gridContainer}
                                >
                                    <Grid container direction="column" alignItems="flex-start" wrap="nowrap">
                                        <Grid item className={classes.titleV1}>
                                            Party Name
                                        </Grid>
                                        <Grid item className={classes.textV1}>
                                            {selectedParty && selectedParty.customerName ? selectedParty.customerName : ""}
                                        </Grid>
                                    </Grid>

                                    <Grid container direction="column" alignItems="flex-end" wrap="nowrap">
                                        <Grid item className={classes.titleV2}>
                                            Balance
                                        </Grid>
                                        <Grid item className={classes.textV2}>
                                            {selectedParty && selectedParty.balance ? numberFormat(selectedParty.balance) : ""}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <div className={classes.mtV2}>
                                    <Form
                                        onSubmit={onSubmit}
                                        initialValues={initialValues}
                                        validate={validate}
                                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                                            submit = handleSubmit; return (
                                                <form onSubmit={handleSubmit} noValidate>
                                                    <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                                            <Grid item xs={item.size} key={idx}>
                                                                {item.field}
                                                            </Grid>
                                                        ) : null)}
                                                    </Grid>
                                                </form>
                                            )
                                        }}
                                    />
                                </div>

                                {showTripError &&
                                    <div className={classes.divTripError}>
                                        Select Trips to Invoice the party.
                                    </div>
                                }

                                <div className={classes.divTable} >
                                    <div className={classes.divAlignV4}>
                                        <div className={classes.titleV4}>
                                            Select Trips
                                        </div>
                                        <div className={classes.divSort}>
                                            <Button className={classes.sortButton} onClick={() => handleSortClick()}>
                                                {sortingText} <SortIconVertical className={classes.sortIcon} />
                                            </Button>
                                        </div>
                                    </div>
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                                    </MuiThemeProvider>
                                </div>
                            </div>
                        </>
                    }

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >
                    <div className={classes.divAlignActions}>

                        {screen == "selectParty" &&
                            <Button variant="contained" className={classes.backButton} onClick={() => handleClose()}>
                                Close
                            </Button>
                        }
                        {screen == "invoiceDetails" &&
                            <>
                                <Button variant="contained" className={classes.backButton} onClick={() => handleBackClick()}>
                                    Back
                                </Button>

                                <Button variant="contained" className={classes.createInvoiceButton} classes={{ disabled: classes.createInvoiceButtonDisabled }}
                                    disabled={confirmDisabled || tripError}
                                    onClick={event => {
                                        submit(event)
                                    }}
                                >
                                    Create Invoice
                                </Button>
                            </>
                        }
                    </div>
                </SideBarDialogActions>

            </Drawer>

            {infoDialog && <InvoiceTripInfoDialog open={infoDialog} onClose={handleInfoClose} tripData={selectedTripInfo} />}
            {enterDaysFlag && <EnterDaysDialog open={enterDaysFlag} onClose={handleDaysDialogClose} onConfirm={handleDaysDialogConfirm} />}
        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetInvoicesDefault: (onSuccess, onFailure) => {
        dispatch(invoicesDefault(onSuccess, onFailure))
    },
    dispatchFetchInvoiceTrips: (partyId, onSuccess, onFailure) => {
        dispatch(fetchInvoiceTrips(partyId, onSuccess, onFailure))
    },
    dispatchGetInvoiceConfig: (onSuccess, onFailure) => {
        dispatch(invoiceConfig(onSuccess, onFailure))
    },
    dispatchCreateInvoice: (invoiceData, onSuccess, onFailure) => {
        dispatch(createInvoice(invoiceData, onSuccess, onFailure))
    },
    dispatchGetInvoiceCustomers: (onSuccess, onFailure) => {
        dispatch(getInvoiceCustomers(onSuccess, onFailure))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(AddInvoiceSideBar);